import { styled } from '@mui/material';

export const LoadingContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(4),
  width: 500,
  height: 400,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
